<template>

<div>
	<div class="content">
		<slot v-bind:localSelectedSection="localSelectedSection"></slot>
	</div>

	<div class="section-controls" v-if="!localSelectedSection">
		<div :class="['button', 'edit']" @click="$emit('selectSection')" v-if="!config.noedit">Edit <i class="fas fa-pen"></i></div>
		<div class="button remove" @click="$emit('removeSection')">Delete <i class="fas fa-trash-alt"></i></div>
		<a class="button" :href="'/dashboard' + linkName" target="_blank" v-if="!config.nolink">Add {{ sectionName }} <i class="fas fa-plus"></i></a>
		<div class="button drag">Move <i class="fas fa-grip-horizontal"></i></div>
	</div>

	<transition name="expand">
		<div class="section-edit" v-if="localSelectedSection">
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span><i class="fas fa-check"></i> Save</span></div>
				<div class="button action" @click="saveTemplateData(config.template_id)" v-else><span v-if="getSaving"><i class="fas fa-spinner fa-spin"></i> Saving...</span><span v-else><i class="fas fa-check"></i> Save</span></div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="$emit('deSelectSection')">Back</div>
				<div class="button cancel" @click="revertTemplateData(); $emit('deSelectSection');" v-else>Cancel</div>
			</div>

			<div class="three-columns">
				<slot name="sectionEdit"></slot>
			</div>
		</div>
	</transition>
</div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
	name: 'template-section',
	props: ['config', 'noedit', 'linkName', 'sectionName'],
	data() {
		return {
			sectionLink: ""
		}
	},
	computed: {
        ...mapState({
            getTemplateDataChanged: (state, getters) => getters['website_module/getTemplateDataChanged'],
            getSaving: (state, getters) => getters['website_module/getSaving']
        }),
		localSelectedSection() {
			return this.config.index == this.config.selectedSection
		}
	},
    methods: {
        ...mapActions('website_module', [
            'saveTemplateData',
            'revertTemplateData'
        ]),
				tellMeTheLink() {
					console.log (this.sectionLinks)
				}
    }
}
</script>
